import { get } from 'lodash';
import useConfirmTipTicket from 'modules/POS/PaymentDetails/ConfirmTipTicket';
import { useTicketWrapper } from 'modules/POS/Receipts/context';
import cashierService from 'modules/POS/services';
import cashierApis from 'modules/POS/services/apis';
import { IApiCashierPaymentBody } from 'modules/POS/services/types/payment';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import toast from 'utils/toast';
import { cashierCtrl } from '../../cashier.controller';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import ModalCashierLoyaltyPayment, { ICashierLoyaltyPaymentMethod, useModalLoyaltyRef } from './ModalLoyalty';
import { useSocketContext } from '../../hooks/useSocket';
type Props = {
  customerPoint?: number;
};
function CashierLoyaltyPayment({ customerPoint = 0 }: Props) {
  const dispatch = useAppDispatch();
  const socketContext = useSocketContext();
  const [completedTicketModalRef, completedTicketModalContext] = useConfirmTipTicket();
  const ref = useModalLoyaltyRef();
  const ticketContext = useTicketWrapper();

  const onLoyalty = async () => {
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) ref.current?.open(billId);
    });
  };

  const onPayment: ICashierLoyaltyPaymentMethod = async (billId, paymentItem) => {
    const body: IApiCashierPaymentBody = {
      billId, payments: [paymentItem],
    };
    try {
      const res: IResponseData<any> = await cashierApis.paymentTicket(body);
      if (res.data.data) {
        socketContext.alertPaymentSuccess(billId);
        dispatch(cashierService.actions.async.lstBillOnHold.fetch());
        const callback = () => {
          cashierCtrl.generateNewTicketAfterPayment();
        };
        if (!completedTicketModalRef.current) {
          ticketContext.completedTicket(billId, true);
          callback();
        } else {
          completedTicketModalRef.current.open(billId, callback);
        }
        return true;
      }
      throw res.data.data;
    } catch (error) {
      const msg = get(error, ['response', 'data', 'message'], 'Fail');
      toast.error(msg);
      return false;
    }
  };

  return (
    <>
      <CashierActionButton
        type={ActionType.LOYALTY}
        onClick={onLoyalty}
        disabled={!customerPoint}
      />
      <ModalCashierLoyaltyPayment ref={ref}
        customerPoint={customerPoint}
        onPayment={onPayment}
      />
      {completedTicketModalContext}
    </>
  );
}

export default CashierLoyaltyPayment;
